import axios from 'axios';

//创建一个axios对象
const instance = axios.create({
  baseURL: "/index.php",
  timeout: 300000,
  headers: {
    'Content-Type': 'application/Json' //改这里就好了
  },
})
instance.interceptors.request.use(
  config => {  
    let token = sessionStorage.getItem('token')
    if (token) {
      config.headers.common['token'] = sessionStorage.getItem('token');
    } else {
      config.headers.common['token'] = '';
    }
    return config
  }, err => {
    return Promise.reject(err);
  }
)
export function get(url, params, ) {
  return instance.get(url, {
    params
  });
}
export function post(url, data) {
  return instance.post(url, data);
}

export function del(url) {
  return instance.delete(url)
}

export function put(url, data) {
  return instance.put(url, data)
}


const instanceX = axios.create({
  baseURL: "get",
  timeout: 20000,
  headers: {
    'Content-Type': 'application/Json' //改这里就好了
  },
})
instanceX.interceptors.request.use(
  config => {
    return config
  }, err => {
    return Promise.reject(err);
  }
)
export function getX(url, params, ) {
  return instanceX.get(url, {
    params
  });
}

export function postX(url, data) {
  return instanceX.post(url, data);
}

export function delX(url) {
  return instanceX.delete(url)
}

export function putX(url, data) {
  return instanceX.put(url, data)
}
export function params(data) {
  let formdata = new FormData()
  for (let i in data) {
    formdata.append([i], data[i])
  }
  return formdata
}